import z from "zod";

const batteryDataV1Schema = z.object({
    percentage: z.object({
        new: z.string(),
        old: z.string(),
    }),
});
const batteryDataV2Schema = z.object({
    ip: z.string().optional(),
    code: z.string().optional(),
    chargeId: z.string().optional(),
    deviceSerial: z.string().optional(),
    battery: z.object({
        new: z.string(),
        old: z.string(),
    }),
});

const batteryDataSchema = batteryDataV2Schema;

type ReturnEvent = API.BaseEvent & {
    eventTypeName: "DeviceEvent.BatteryAlertDetected";
    type: 2002;
    dataVersion: 2;
    data: z.infer<typeof batteryDataSchema> | null;
};

function migrateBatteryAlertEvent(event: API.DeviceBatteryAlertEvent): ReturnEvent {
    if (event.dataVersion === 1) {
        const v1 = batteryDataV1Schema.safeParse(event.data);
        if (v1.success) {
            return {
                ...event,
                dataVersion: 2,
                data: { battery: v1.data.percentage },
            };
        }
    }

    if (event.dataVersion === 2 && batteryDataV2Schema.safeParse(event.data).success) {
        return event;
    }

    return { ...event, data: null, dataVersion: 2 };
}

export { batteryDataSchema, migrateBatteryAlertEvent };
